<template>
    <div class="el-form-card">
        <div class="el-form-card__header">
            {{ $t('form.title.create') }} {{ $t('form.title.waitingArea') }}
        </div>
        <div class="el-form-card__body">
            <el-form
                ref="form"
                class="dark-form"
                :model="form"
                size="mini"
                label-position="top"
                label-width="125px"
                style="min-height: 680px"
            >
                <el-row>
                    <div class="el-form-card__element-wrapper">
                        <el-form-item prop="Description">
                            <v-text-field
                                :label="$t('form.label.description')"
                                v-model="form.description"
                                required
                            ></v-text-field>
                        </el-form-item>
                    </div>
                </el-row>

                <el-row>
                    <div class="el-form-card__element-wrapper">
                        <el-form-item prop="shortDescription">
                            <v-text-field
                                :label="$t('form.label.shortDescription')"
                                v-model="form.shortDescription"
                                required
                            ></v-text-field>
                        </el-form-item>
                    </div>
                </el-row>

                <el-row>
                    <div class="el-form-card__element-wrapper">
                        <el-form-item prop="maxCapacity">
                            <v-text-field
                                :label="$t('table.column.maxCapacity')"
                                v-model="form.maxCapacity"
                                required
                                type="number"
                                min="0"
                            ></v-text-field>
                        </el-form-item>
                    </div>
                </el-row>

                <el-row>
                    <div class="el-form-card__element-wrapper">
                        <v-select
                            :items="associatedCheckpoints"
                            :label="$t('form.label.associatedCheckpoints')"
                            item-text="CommonName"
                            item-value="CheckpointID"
                            v-model="form.associatedCheckpoints"
                            return-object
                            multiple
                            required
                            chips
                            dark
                        >
                        </v-select>
                    </div>
                </el-row>

                <el-row>
                    <div class="el-form-card__element-wrapper">
                        <el-form-item prop="geoLocation">
                            <el-col :span="22">
                                <v-text-field
                                    :label="$t('form.label.geoLocation')"
                                    v-model="form.geoLocation"
                                    required
                                ></v-text-field>
                            </el-col>
                            <el-col :span="2">
                                <v-icon
                                    class="location-icon"
                                    color="red darken-3"
                                    >location_on</v-icon
                                >
                            </el-col>
                        </el-form-item>
                    </div>
                    <div>
                        <stc-google-map
                            :latLngStr="form.geoLocation"
                            @updatedLatLngStr="form.geoLocation = $event"
                            class="map-placeholder"
                        />
                    </div>
                </el-row>

                <el-row style="margin-top: 30px">
                    <div
                        class="
                            el-form-card__element-wrapper
                            el-form-card__element-wrapper--expander
                        "
                    >
                        <el-form-item prop="activeWaitingArea">
                            <div class="el-checkbox-list">
                                <v-checkbox
                                    :label="$t('form.label.waitingAreaActive')"
                                    v-model="form.activeWaitingArea"
                                    color="success"
                                    hide-details
                                >
                                </v-checkbox>
                            </div>
                        </el-form-item>
                    </div>
                </el-row>

                <el-row>
                    <div class="el-form-card__element-wrapper">
                        <el-form-item prop="Color">
                            <div class="text-grey mt-2">
                                {{ $t('form.label.chooseColor') }}
                            </div>
                            <swatches v-model="form.color" :colors="colors" />
                        </el-form-item>
                    </div>
                </el-row>

                <div class="button-wrapper flex justify-between items-center">
                    <v-btn
                        round
                        color="primary"
                        @click="submit"
                        :disabled="loading"
                        dark
                    >
                        {{ formText }}
                    </v-btn>
                    <v-btn round @click.prevent="reset" color="dark" dark>
                        {{ $t('form.button.cancel') }}
                    </v-btn>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Swatches from 'vue-swatches'
import GoogleMap from '../../components/map/GoogleMap.vue'
import { Constants } from './../../constants.js'

export default {
    name: 'create-waiting-areas',

    components: { Swatches, 'stc-google-map': GoogleMap },

    data() {
        return {
            editing: false,
            loading: false,
            waitingArea: '',
            colors: [
                [
                    '#9fa8da',
                    '#00bcd4',
                    '#c0ca33',
                    '#4db6ac',
                    '#f06292',
                    '#9b84c3',
                    '#f9a825',
                    '#ccc68d',
                    '#81c784',
                    '#00b4ff',
                    '#90a4ae',
                    '#eec290',
                    '#a7848b',
                    '#9e9e9e',
                    '#bcaaa4',
                ],
            ],
            form: {
                description: '',
                shortDescription: '',
                associatedCheckpoints: [],
                maxCapacity: null,
                color: '#9fa8da',
                colorCode: '',
                activeWaitingArea: false,
                geoLocation: Constants.DefaultGeoCoordinates,
            },
            showMap: false,
        }
    },

    props: {
        associatedCheckpoints: Array,
    },

    created() {
        if (this.selectedContainer.Coordinates) {
            this.form.geoLocation = this.selectedContainer.Coordinates
        }
    },

    mounted() {
        Events.$on('waiting-area-editing', async (data) => {
            this.editing = true
            this.waitingArea = data

            this.fillFormUser(this.waitingArea)
        })
    },

    computed: {
        ...mapGetters(['selectedContainer']),

        waitingAreaPayload() {
            return {
                ContainerID: this.selectedContainer.ContainerID,
                Description: this.form.description,
                ShortDescription: this.form.shortDescription,
                GeoLocation: this.form.geoLocation,
                MaxCapacity: Number(this.form.maxCapacity),
                Color: this.form.color,
                IsActive: this.form.activeWaitingArea,
                ExtendedInfo: this.form.extendedInfo,
                RelatedCheckpointIDs: this.form.associatedCheckpoints.map(
                    (it) => it.CheckpointID
                ),
            }
        },

        formText() {
            return this.editing
                ? this.$t('form.title.update')
                : this.$t('form.title.create')
        },
    },

    methods: {
        async submit() {
            this.loading = true

            let method = this.editing ? 'put' : 'post'
            let url = this.editing
                ? `WaitingArea/${this.waitingArea.WaitingAreaID}`
                : 'WaitingArea'

            await this.$http[method](url, this.waitingAreaPayload)

            this.$message({
                type: 'success',
                showClose: true,
                message: this.editing
                    ? this.$i18n.i18next.t('message.success.updated', {
                          section: this.$i18n.i18next.t(
                              'form.label.waitingArea'
                          ),
                      })
                    : this.$i18n.i18next.t('message.success.created', {
                          section: this.$i18n.i18next.t(
                              'form.label.waitingArea'
                          ),
                      }),
            })

            this.notifyUnloadingAreaUpdate()
            this.reset()

            this.loading = false
        },

        reset() {
            this.waitingArea = ''
            this.form.description = ''
            this.form.shortDescription = ''
            this.form.associatedCheckpoints = []
            this.form.geoLocation = ''
            this.form.color = '#9fa8da'
            this.form.maxCapacity = null
            this.form.colorCode = ''
            this.form.activeWaitingArea = false
            this.editing = false
            this.form.geoLocation = Constants.DefaultGeoCoordinates
        },

        notifyUnloadingAreaUpdate() {
            Events.$emit('waiting-area-updated')
        },

        fillFormUser(waitingArea) {
            this.form.description = waitingArea.Description
            this.form.shortDescription = waitingArea.ShortDescription
            this.form.shortDescription = waitingArea.ShortDescription
            this.form.maxCapacity = waitingArea.MaxCapacity
            this.form.geoLocation = waitingArea.GeoLocation
            this.form.color = waitingArea.Color
            this.form.activeWaitingArea = waitingArea.IsActive
            this.form.extendedInfo = waitingArea.ExtendedInfo
            this.form.geoLocation = waitingArea.GeoLocation
            this.form.associatedCheckpoints = waitingArea.Checkpoints
        },
    },
}
</script>
<style scoped>
.location-icon {
    margin-top: 20px;
    cursor: pointer;
}
.map-placeholder {
    height: 250px;
}
</style>